import TagSectionItem, { TagSectionItemProps } from './TagSectionItem';

export type { TagSectionItemProps };
export default TagSectionItem;
